import { render, staticRenderFns } from "./AddressBookContactActions.vue?vue&type=template&id=be7e861e&"
import script from "./AddressBookContactActions.vue?vue&type=script&lang=ts&"
export * from "./AddressBookContactActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports